export enum PaymentPoliciesTabs {
    SettlementRules = 'settlementRules',
    CancellationPolicies = 'cancellationPolicies',
}
